import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "cluster-wizard" }
const _hoisted_2 = { class: "cluster-wizard__sidebar" }
const _hoisted_3 = { class: "cluster-wizard__section" }
const _hoisted_4 = { class: "heading-xl" }
const _hoisted_5 = { class: "cluster-wizard__group" }
const _hoisted_6 = {
  key: 0,
  class: "cluster-wizard__section"
}
const _hoisted_7 = { class: "heading-xl" }
const _hoisted_8 = {
  key: 1,
  class: "cluster-wizard__section"
}
const _hoisted_9 = { class: "heading-xl" }
const _hoisted_10 = {
  key: 2,
  class: "cluster-wizard__section"
}
const _hoisted_11 = { class: "label-xs cluster-wizard__help-text" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "cluster-wizard__help-image" }, null, -1)
const _hoisted_13 = { class: "cluster-wizard__section" }
const _hoisted_14 = { class: "cluster-wizard__content" }
const _hoisted_15 = {
  key: 0,
  class: "cluster-wizard__section"
}
const _hoisted_16 = { class: "heading-xl" }
const _hoisted_17 = { class: "cluster-wizard__line" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "cluster-wizard__cluster-pad" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "cluster-wizard__section"
}
const _hoisted_20 = { class: "heading-xl" }
const _hoisted_21 = { class: "cluster-wizard__line" }
const _hoisted_22 = {
  key: 2,
  class: "cluster-wizard__section"
}
const _hoisted_23 = { class: "heading-xl" }
const _hoisted_24 = { class: "cluster-wizard__line" }
const _hoisted_25 = {
  key: 3,
  class: "cluster-wizard__section"
}
const _hoisted_26 = { class: "heading-xl" }
const _hoisted_27 = { class: "cluster-wizard__line" }
const _hoisted_28 = { class: "cluster-wizard__form" }
const _hoisted_29 = { class: "cluster-wizard__save" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParticipantItemRow = _resolveComponent("ParticipantItemRow")!
  const _component_ClusterItem = _resolveComponent("ClusterItem")!
  const _component_ClusterItemRow = _resolveComponent("ClusterItemRow")!
  const _component_CardItemRow = _resolveComponent("CardItemRow")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_ClusterWizardItem = _resolveComponent("ClusterWizardItem")!
  const _component_ParticipantItem = _resolveComponent("ParticipantItem")!
  const _component_CardItemTile = _resolveComponent("CardItemTile")!
  const _component_NModalWindow = _resolveComponent("NModalWindow")!
  const _component_NForm = _resolveComponent("NForm")!
  const _directive_scroll_horizontally = _resolveDirective("scroll-horizontally")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NModalWindow, {
      layout: true,
      "has-margins": false,
      customSize: "90vw",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.participant)
                ? (_openBlock(), _createBlock(_component_ParticipantItemRow, {
                    key: 0,
                    class: "cluster-wizard__participant",
                    item: _ctx.participant,
                    closeable: false
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('cases.clusters')), 1),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainClusterAndSelectedClusters, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "cluster-wizard__group-item",
                    key: item.id
                  }, [
                    (_ctx.mainClusterAndSelectedClusters.length === 1)
                      ? (_openBlock(), _createBlock(_component_ClusterItem, {
                          key: 0,
                          item: item,
                          canAcknowledge: false,
                          onAction: () => _ctx.clusterItemAction(item.id)
                        }, null, 8, ["item", "onAction"]))
                      : (_openBlock(), _createBlock(_component_ClusterItemRow, {
                          key: 1,
                          item: item,
                          canClose: item.id !== _ctx.cluster.id,
                          onAction: (v) => _ctx.actionHandler(`cluster_${v}`, item)
                        }, null, 8, ["item", "canClose", "onAction"]))
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.allSelectedParticipants.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('cases.participants')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSelectedParticipants, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "cluster-wizard__row-item",
                      key: item.id
                    }, [
                      _createVNode(_component_ParticipantItemRow, {
                        item: item,
                        onAction: (v) => _ctx.actionHandler(`any_participant_${v}`, item)
                      }, null, 8, ["item", "onAction"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedCards.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('cases.card_index')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCards, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "cluster-wizard__row-item",
                      key: item.id
                    }, [
                      _createVNode(_component_CardItemRow, {
                        type: "humans",
                        item: item,
                        "show-actions": false,
                        onAction: (v) => _ctx.actionHandler(`card_${v}`, item)
                      }, null, 8, ["item", "onAction"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.allSelectedParticipants.length && !_ctx.selectedCards.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('cases.wizard_help_text')), 1),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.participant)
                ? (_openBlock(), _createBlock(_component_NButton, {
                    key: 0,
                    disabled: !_ctx.participantsAcl.add,
                    icon: "participant-create",
                    widen: "",
                    onClick: _ctx.saveHandler
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cases.save_participant')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_component_NButton, {
                    key: 1,
                    disabled: !_ctx.participantsAcl.update,
                    icon: "participant-create",
                    widen: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateForm = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cases.create_new_participant')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.clusterItemsFiltered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('cases.clusters')), 1),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusterItemsFiltered, (item) => {
                      return (_openBlock(), _createBlock(_component_ClusterWizardItem, {
                        key: item.id,
                        confidence: item.looks_like_confidence,
                        onAction: (v) => _ctx.actionHandler(`cluster_${v}`, item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ClusterItem, {
                            item: item,
                            canAcknowledge: false,
                            onAction: () => _ctx.clusterItemAction(item.id)
                          }, null, 8, ["item", "onAction"]),
                          _hoisted_18
                        ]),
                        _: 2
                      }, 1032, ["confidence", "onAction"]))
                    }), 128))
                  ])), [
                    [_directive_scroll_horizontally]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.participantsItemsFiltered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('cases.participants_in_current_case')), 1),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participantsItemsFiltered, (item) => {
                      return (_openBlock(), _createBlock(_component_ClusterWizardItem, {
                        key: item.id,
                        confidence: item.looks_like_confidence,
                        onAction: (v) => _ctx.actionHandler(`participant_${v}`, item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParticipantItem, { item: item }, null, 8, ["item"])
                        ]),
                        _: 2
                      }, 1032, ["confidence", "onAction"]))
                    }), 128))
                  ])), [
                    [_directive_scroll_horizontally]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.otherParticipantsItemsFiltered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('cases.participants_in_other_cases')), 1),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherParticipantsItemsFiltered, (item) => {
                      return (_openBlock(), _createBlock(_component_ClusterWizardItem, {
                        key: item.id,
                        confidence: item.looks_like_confidence,
                        onAction: (v) => _ctx.actionHandler(`other_participant_${v}`, item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParticipantItem, { item: item }, null, 8, ["item"])
                        ]),
                        _: 2
                      }, 1032, ["confidence", "onAction"]))
                    }), 128))
                  ])), [
                    [_directive_scroll_horizontally]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.cardsItemsFiltered.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('cases.card_index')), 1),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardsItemsFiltered, (item) => {
                      return (_openBlock(), _createBlock(_component_ClusterWizardItem, {
                        key: item.id,
                        confidence: item.looks_like_confidence,
                        onAction: (v) => _ctx.actionHandler(`card_${v}`, item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CardItemTile, {
                            type: "humans",
                            item: item
                          }, null, 8, ["item"])
                        ]),
                        _: 2
                      }, 1032, ["confidence", "onAction"]))
                    }), 128))
                  ])), [
                    [_directive_scroll_horizontally]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.showCreateForm)
      ? (_openBlock(), _createBlock(_component_NModalWindow, {
          key: 0,
          layout: "true",
          label: _ctx.$t('cases.create_new_participant'),
          customSize: "570px",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCreateForm = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_NForm, {
                ref: "form",
                layout: _ctx.informationLayout,
                model: _ctx.newParticipant
              }, null, 8, ["layout", "model"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_NButton, {
                type: "primary",
                disabled: !_ctx.participantsAcl.add,
                onClick: _ctx.createHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('cases.save_and_done', 'f')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["label"]))
      : _createCommentVNode("", true)
  ], 64))
}